import React from "react";
import "./Hero.css";
import { Link } from "react-router-dom";
import saveTodayBanner from "../../assets/images/IZB/IZB Website Skin/Save Today. Win Tomorrow._Website_Banner.png";

const HeroSlide9 = () => {
  return (
    <Link to="/SaveTodayWinTomorrow">
      <img src={saveTodayBanner} alt="hero-banner-desktop" className="hide-on-mobile home-hero-banner" />
      <img src={saveTodayBanner} alt="hero-banner-mobile" className="hide-on-desktop home-hero-banner" />
    </Link>
  );
};

export default HeroSlide9;
